// extracted by mini-css-extract-plugin
export default {"cls1":"TagSelector-cls1__ccc8d65b033ed293be94","cls2":"TagSelector-cls2___6bf5e2ef746002c973f TagSelector-cls1__ccc8d65b033ed293be94"};